import React, { useState } from "react";
import './AppHeader.scss';
import {signOut} from "aws-amplify/auth";
import {Link, useNavigate} from "react-router-dom";
import { AppBar, Toolbar, Typography, Box, Avatar, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { Person, Subscriptions, Logout } from "@mui/icons-material";
import { connect } from 'react-redux';

const AppHeader = (props) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const navigate = useNavigate();
	const open = Boolean(anchorEl);

	const handleAvatarClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (path) => {
		handleClose();
		if (path) {
			navigate(path);
		}
	};

	const logout = () => {
		handleClose();
		signOut();
	};

	return (
		<AppBar position="static" color="transparent" elevation={0} className={(props.authStatus === 'authenticated' ? 'User' : 'Guest') + (props.isHome ? ' Home' : '')}>
			<Toolbar>
				<Box sx={{ flexGrow: 1 }}>
					<Link to={'/'}>
						<img alt="Everyday Events" src={"/logo.svg"} id={'logo'}/>
					</Link>
				</Box>
				{props.authStatus === 'authenticated' && (
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
						<Typography variant="body1">{props.userData.username}</Typography>
						<Avatar 
							alt={props.userData.username} 
							src={props.userData.avatarUrl}
							sx={{ width: 40, height: 40, cursor: 'pointer' }}
							onClick={handleAvatarClick}
						>
							{props.userData.username?.charAt(0)?.toUpperCase()}
						</Avatar>
						<Menu
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'right',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
						>
							<MenuItem onClick={() => handleMenuItemClick('/profile/details')}>
								<ListItemIcon>
									<Person fontSize="small" />
								</ListItemIcon>
								<ListItemText>Profile</ListItemText>
							</MenuItem>
							<MenuItem onClick={() => handleMenuItemClick('/profile/subscriptions')}>
								<ListItemIcon>
									<Subscriptions fontSize="small" />
								</ListItemIcon>
								<ListItemText>My Subscription</ListItemText>
							</MenuItem>
							<MenuItem onClick={logout}>
								<ListItemIcon>
									<Logout fontSize="small" />
								</ListItemIcon>
								<ListItemText>Logout</ListItemText>
							</MenuItem>
						</Menu>
					</Box>
				)}
			</Toolbar>
		</AppBar>
	);
}

const mapStateToProps = state => {
	return {
		userData: state.userData
	};
};

export default connect(mapStateToProps)(AppHeader);
